import { render, staticRenderFns } from "./lci-lca.vue?vue&type=template&id=7563f2be&scoped=true&"
import script from "./lci-lca.vue?vue&type=script&lang=js&"
export * from "./lci-lca.vue?vue&type=script&lang=js&"
import style0 from "./lci-lca.vue?vue&type=style&index=0&id=7563f2be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7563f2be",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7563f2be')) {
      api.createRecord('7563f2be', component.options)
    } else {
      api.reload('7563f2be', component.options)
    }
    module.hot.accept("./lci-lca.vue?vue&type=template&id=7563f2be&scoped=true&", function () {
      api.rerender('7563f2be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/tiposAtivos/RendaFixa/lci-lca.vue"
export default component.exports